import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './index.module.css';
import { faEnvelope, faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useState } from 'react';
import LandingVideo from '../../../assets/images/landingPage/landing_video.mp4';

const ContactUs = () => {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [errorMessages, setErrorMessages] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [isSuccess, setSuccess] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  const validateEmail = (email) =>
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);

  const validateFormData = () => {
    const errors = {};
    const trimmedName = formData.name.trim();
    const trimmedEmail = formData.email.trim();
    const trimmedSubject = formData.subject.trim();
    const trimmedMassage = formData.message.trim();
    if (!trimmedName) {
      errors.name = "Name is required.";
    }
    if (!trimmedEmail) {
      errors.email = "Email is required.";
    }
    if (trimmedEmail && !validateEmail(trimmedEmail)) {
      errors.email = 'Please add a valid email.'
    }
    if (!trimmedSubject) {
      errors.subject = "Subject is required.";
    }
    if (!trimmedMassage) {
      errors.message = "Message is required.";
    }
    if (Object.keys(errors).length > 0) {
      setErrorMessages(errors);
      return false;
    } else {
      return true;
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrorMessages((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const inquirySubmission = () => {
    if (validateFormData()) {
      const mailtoLink = `mailto:kavishka@ardillalabs.com?subject=${encodeURIComponent(
        formData.subject
      )}&body=${encodeURIComponent(
        `Hello,

You have received a new contact request:

----------------------------------
Name    : ${formData.name}
Email   : ${formData.email}

Message:
${formData.message}
----------------------------------

Thanks & Regards,
${formData.name}`
      )}`;

      window.open(mailtoLink, "_blank");
    }
  };

  return (
    <div className={`main-container ${styles.contactUs}`}>
      <video
        className={styles.backgroundVideo}
        src={LandingVideo}
        autoPlay
        muted
        loop
        playsInline
        aria-hidden="true"
      />
      <div className={`container-content`}>
        <div className={styles.aboutUsContainer}>
          <div className={styles.aboutUsCard}>
            <p className={styles.cardTitle}>
              Get In Touch
            </p>
            <p className={styles.cardText}>
              Ready to transform your business? Let’s talk.
            </p>
          </div>
          <div className={styles.contactCard}>
            <div className={styles.contactLeft}>
              <p className={styles.contactTitle}>Contact Information</p>
              <p className={styles.contactText}>We’d love to hear from you. Reach out to us by sending us an email anytime, and our team will get back to you as soon as possible.</p>
              <div className={styles.iconRow} style={{ marginTop: '50px' }}><FontAwesomeIcon icon={faPhone} className={styles.contactIcon} />
                <a href="tel:+94777634902" className={styles.contactLink}>
                  077 763 4902
                </a>
              </div>
              <div className={styles.iconRow}><FontAwesomeIcon icon={faEnvelope} className={styles.contactIcon} />info@ardillalabs.com</div>
              <div className={styles.iconRow}><FontAwesomeIcon icon={faLocationDot} className={styles.contactIcon} />No 16, Ambaraluwa North, Weliweriya</div>
            </div>
            <div className={styles.contactRight}>
              <div className={styles.container}>
                <div className={styles.formContainer}>
                  <p className={styles.contactTitle}>Contact Information</p>
                  <p className={styles.contactText}>Fill out the form below and we’ll be in touch soon. </p>
                  <form noValidate className={styles.contactForm}>
                    <div className={`form-input-row`}>
                      <div className={`form-input-group`}>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleInputChange}
                          placeholder='Your name'
                          className={`${styles.contactInput} ${styles.formInput}`}
                        />
                        {errorMessages.name && (
                          <p className={`text-danger`}>
                            {errorMessages.name}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className={`form-input-row`}>
                      <div className={`form-input-group`}>
                        <input
                          type="text"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          placeholder='Your email'
                          className={`${styles.contactInput} ${styles.formInput}`}
                        />
                        {errorMessages.email && (
                          <p className={`text-danger`}>
                            {errorMessages.email}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className={`form-input-row`}>
                      <div className={`form-input-group`}>
                        <input
                          type="text"
                          id="subject"
                          name="subject"
                          value={formData.subject}
                          onChange={handleInputChange}
                          placeholder='Subject'
                          className={`${styles.contactInput} ${styles.formInput}`}
                        />
                        {errorMessages.subject && (
                          <p className={`text-danger`}>
                            {errorMessages.subject}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className={`form-input-row`}>
                      <div className={`form-input-group`}>
                        <textarea
                          id="message"
                          name="message"
                          value={formData.message}
                          onChange={handleInputChange}
                          placeholder='Message'
                          className={`${styles.contactInput} ${styles.formInput} ${styles.textarea}`}
                        />
                        {errorMessages.message && (
                          <p className={`text-danger`}>
                            {errorMessages.message}
                          </p>
                        )}
                      </div>
                    </div>
                    <button className={styles.submitBtn} type="button" onClick={inquirySubmission}>
                      Submit
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    </div >
  )
}

export default ContactUs;